<template>
  <div class="container">
    <div class="nucleicAcidTestMain" ref="nucleicAcidTestMain">
      <div class="wrapper">
        <!-- <Head class="d1" :logo="logo"></Head> -->
        <!-- logo组件 -->
        <!-- <Logo ref="lopic" :bg-color="bgColor"></Logo> -->
        <Head :logo="logo"></Head>

        <div class="con">
          <div class="til">
            <p class="con_title">
              <img src="../../assets/img/paymentUnit.png" alt="姓名" />
              <span>考生姓名</span>
            </p>
            <div class="con_in">
              <input
                type="text"
                id="myInput1"
                v-model="formData.paymentUnit"
                maxlength="90"
                placeholder="请输入考生姓名"
              />
            </div>
          </div>
          <div class="sfzh">
            <p class="con_title">
              <img src="../../assets/img/paymentUnitPhone.png" />
              <span>手机号码</span>
            </p>
            <div class="con_in">
              <input
                maxlength="18"
                type="text"
                v-model.trim="formData.phone"
                placeholder="请输入手机号码"
                ref="phone"
                @change="phonechange"
              />
            </div>
            <div class="error" v-show="phoneShow">
              您输入的手机号码错误，请重新输入
            </div>
          </div>
          <div class="sfzh">
            <p class="con_title">
              <img src="../../assets/img/virifyCode.png" />
              <span>验证码</span>
            </p>
            <div class="con_in Verification">
              <input
                maxlength="6"
                type="text"
                v-model.trim="formData.verifiCode"
                placeholder="请输入短信验证码"
                ref="phone"
              />
              <p
                v-if="disabledShow"
                class="getVerification"
                @click="getVerification"
              >
                获取验证码
              </p>
              <p v-else class="getVerification">{{ timer }}秒后重试</p>
            </div>
          </div>
          <div class="con_btn">
            <button @click="sub">查询</button>
          </div>
          <PrivacyDialog
            person="1"
            ref="privacyDialog"
            @getReadState="getReadState"
          ></PrivacyDialog>
        </div>
      </div>
    </div>
    <Foot
      v-if="
        isOriginHeight &&
        list &&
        list.bottomMessage &&
        list.bottomMessage.length > 0
      "
      :list="list"
    ></Foot>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { judgeVde } from "@/utils/publicJudge";
import { Toast,Dialog } from "vant";
import PrivacyDialog from "@/components/dialog/privacyDialog";
import { savePrivacy } from "@/utils/common.js";
import Foot from "@/components/foot";
import Head from "@/components/head";

// 全局注册
export default {
  components: {
    Head,
    Foot,
    PrivacyDialog,
  },
  data() {
    return {
      checkRead: false,
      screenHeight: document.documentElement.clientHeight, // 当前高度
      originHeight: document.documentElement.clientHeight, //默认高度，用作比较
      isOriginHeight: true, //当前高度是否仍等于默认高度,
      vde: "",
      logo: "",
      list: [],
      bgColor: "#0091ff",
      isRead: "",
      verificationShow: false,
      formData: {
        paymentUnit: "",
        phone: "",
        verifiCode: "",
      },
      phoneShow: false,
      show: false,
      disabledShow: true,
      timer: 60,
      deptId:'',
    };
  },
  watch: {
    screenHeight(val) {
      if (this.originHeight - val > 60) {
        //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.isOriginHeight = false;
      } else {
        this.isOriginHeight = true;
      }
    },
  },
  created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    if (this.$route.query.deptId === undefined) {
      this.deptId = "";
    } else {
      this.deptId = this.$route.query.deptId;
    }
    //判断vde
    judgeVde({ vde: this.vde }, this);
    this.getHeadImg();
    // 进来之后获取一次头部和底部信息
    this.getFootData();
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenHeight = document.documentElement.clientHeight;
      })();
    };
    // this.verification()
  },
  methods: {
    getVerification() {
      if (this.formData.phone.length > 0 && this.phoneShow == false) {
        // 请求接口获取数据，获取成功则发送验证码
        let obj = {
          name: this.formData.paymentUnit,
          phone: this.formData.phone,
          deptId: this.deptId,
        };
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url: `/sms/sendRefundVerifiCode`,
          method: "post",
          data: obj,
        }).then((res) => {
          // console.log(res)
          if (res.data.code == 1000) {
            Toast({ message: res.data.message, icon: "none" });
            // 只有响应为1000 才会进行倒计时
            this.disabledShow = false;
            const authTimer = setInterval(() => {
              this.timer--;
              if (this.timer <= 0) {
                this.disabledShow = true;
                this.timer = 60;
                clearInterval(authTimer);
              }
            }, 1000);
          } else {
            Toast({ message: res.data.message, icon: "none" });
          }
        });
      } else {
        if (this.formData.phone.length == 0)
          Toast({ message: "手机号码不能为空", icon: "none" });
        if (this.phoneShow == true)
          Toast({ message: "手机号码格式错误", icon: "none" });
      }
    },
    phonechange() {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (this.formData.phone.length) {
        if (reg.test(this.formData.phone)) {
          this.phoneShow = false;
        } else {
          this.phoneShow = true;
        }
      } else {
        this.phoneShow = false;
      }
    },

    closeO() {
      this.showD = false;
    },
    getReadState(isRead, details) {
      this.isRead = isRead;
      this.details = details;
    },
    // 存储隐私授权接口
    savePrivacy() {
      let data = {
        details: this.details,
        userId: this.formData.paymentUnit,
        userName: this.formData.phone,
      };
      savePrivacy(data);
    },

    getHeadImg() {
      let data = {};
      data.vde = this.vde;
      this.request({
        url: "/webPortal/websitConfig",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code == 1000) {
          if (res.data.result.logoUrlLogin) {
            this.logo = res.data.result.logoUrlLogin;
          } else {
            this.logo = require("@/assets/img/logo.png");
          }
          document.title = res.data.result.websitTitle;
          sessionStorage.setItem("title", res.data.result.websitTitle);
        } else if (res.data.code != 1000) {
          this.$router.push({ path: "/404" });
        }
      });
    },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 18,
      };
      this.request({
        url: "/systemManage/mobileGetMessage",
        method: "get",
        params: data,
      }).then((res) => {
        if (res.data.code != 1000) {
          //this.$router.push({path:'/404'})
        } else {
          this.list = res.data.result;
        }
      });
    },

    check() {
      var user = this.formData.paymentUnit.replace(/(^\s*)|(\s*$)/g, "");
      var phone = this.formData.phone.replace(/(^\s*)|(\s*$)/g, "");
      var code = this.formData.verifiCode.replace(/(^\s*)|(\s*$)/g, "");
      if (user.length == 0) {
        this.agree = false;
        Toast({ message: "缴款单位/人不能为空", icon: "none" });
        return;
      } else if (phone.length == 0) {
        this.agree = false;
        Toast({
          message: "手机号码不能为空",
          icon: "none",
        });
        return;
      } else if (phone.length > 0) {
        let reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (this.formData.phone.length) {
          if (reg.test(this.formData.phone)) {
            this.phoneShow = false;
          } else {
            this.agree = false;
            this.phoneShow = true;
          }
        }
      } 
      if(!code&&!this.phoneShow){
        this.agree = false;
        Toast({ message: "验证码不能为空", icon: "none" });
      }
    },
    sub() {
      this.agree = true;
      this.check();
      if (!this.agree) {
        return;
      }
      if (this.isRead == false) {
        this.$refs.privacyDialog.open();
        return;
      }
      let data={
        paymentUnit:this.formData.paymentUnit,
        phone:this.formData.phone,
        deptId:this.deptId,
        // verifiCode:this.formData.verifiCode
      }
      // 提交
      if (this.agree) {
        this.savePrivacy();
        // /refundPay/listH5RefundData
        this.request({
          baseURL: process.env.VUE_APP_PAY_URL,
          url:'/refundPay/confirmRefundVerify',
          method:'get',
          params:{
            phone:this.formData.phone,
            verifiCode:this.formData.verifiCode
          }
        }).then(res=>{
          if(res.data.code==1000){
            this.$router.push({
              path: "/refundModify/result",
              query: {
                vde:this.vde,
                ...data
              },
            });
          }else{
            Dialog.alert({
              title: '提示',
              message: res.data.message,
            }).then(() => {
            });
          }
        })
        
      }
    },
  }, 
};
</script>
<style lang="scss" scoped>
.container {
  ::v-deep .footNotice {
    width: 100vw;
    margin-top: 0;
    margin-left: 0;
    left: 0;
    font-size: 0.32rem;
    font-family: PingFang SC;
    color: #666;
    line-height: 0.58667rem;
    text-align: left;
    background: #fff;
    padding: 0 0.33333rem;
    box-sizing: border-box;
  }
}
.van-checkbox {
  margin-bottom: 25px !important;
}
.d1 {
  height: 103px !important;
  ::v-deep img {
    height: 103px !important;
  }
}
.container {
  min-height: 100vh;
  position: relative;
  background: #fff;
}
.nucleicAcidTestMain {
  background: #fff !important;

  .van-nav-bar {
    background: #2f2f2f !important;
    .van-icon {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.85);
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.85);
    }
  }
}

.wrapper {
  padding-top: 10px;
  div:nth-of-type(1) {
    width: 96%;
    display: block;
    margin: 0 auto;
  }
  ::v-deep .logo {
    margin-top: 0px !important;
  }
}

.con {
  margin: 0 auto;
  margin-top: 32px;
  padding: 0px 24px;
  box-sizing: border-box;
  ::v-deep .noticeText {
    span {
      color: #1989fa !important;
    }
  }
  .til {
    width: 100% !important;
  }
  .con_title {
    display: flex;
    img {
      width: 20px;
      height: 20px;
      //   background: #0091ff;
      margin-right: 2px;
    }
    span {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2e3133;
      line-height: 22px;
      height: 22px;
      align-items: center;
    }
  }
  .con_in {
    width: 100% !important;
    margin-top: 10px;
    border-bottom: 1px solid #1989fa;
    position: relative;
    img {
      width: 22px;
      height: 14px;
      position: absolute;
      right: 0;
      bottom: 7px;
    }
    input {
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #a1abb3;
      background: transparent !important;
      line-height: 20px;
      padding-bottom: 7px;
      width: 100%;
    }
  }
  .con_btn {
    height: 44px;
    border-radius: 6px;
    position: relative;
    button {
      width: 100%;
      height: 44px;
      background: #1989fa;
      border-radius: 7px;
      font-size: 18px;
      color: #fff;
      border: none;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
    .shadow {
      position: absolute;
      z-index: 0;
      left: 14px;
      top: 7px;
      width: 275px;
      height: 44px;
      background: #00b4fa;
      border-radius: 7px;
      opacity: 0.5;
      filter: blur(10px);
    }
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 12px;
  }
}
.sfzh {
  // height: 82px;
  margin-top: 27px;
  .error {
    margin-top: 5px;
    width: 192px;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #d9001b;
    line-height: 17px;
  }
}
.notice {
  height: 19px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #a1abb3;
  line-height: 19px;
  span {
    color: #0091ff;
  }
}
.Verification {
  position: relative;
  .getVerification {
    position: absolute;
    right: 5px;
    color: #1989fa;
    font-size: 14px;
    top: 4px;
  }
}
.bot {
  // position: relative;
  // bottom: 15px;
  // text-align:center;
  // left: 50%;
  // transform: translate(-50%, 0);
  // font-size: 13px;
  // font-weight: 400;
  // color: #a1abb3;
  // line-height: 19px;
  position: relative;
  background: #fff;
  font-size: 0.32rem;
  font-family: PingFang SC;
  color: #666;
  line-height: 0.58667rem;
  text-align: center;
  box-sizing: border-box;
}
.schoolSelectBox {
  ::v-deep .van-picker-column__item {
    text-align: center;
    line-height: 20px;
    height: 1.8rem;
  }
  ::v-deep .deptIdBox {
    font-size: 14px;
  }
  ::v-deep .deptIdName {
    font-weight: 500;
  }
  ::v-deep .van-picker-column__item--selected {
    //  color: #409EFF;
    //  border-top: 2px solid #409EFF;
    //  border-bottom: 2px solid #409EFF;
    //  box-sizing: border-box;
  }
  ::v-deep .van-picker__frame::after {
    border: none;
  }
}
</style>